export default __webpack_public_path__ + "images/definir-senha-ico.svg";